import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../../../utils/NotificationContext';
import { FaCheckCircle, FaExclamationCircle, FaExclamationTriangle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import './Notification.css';

const NotificationItem = ({ notification }) => {
    const { removeNotification } = useNotification();
    const navigate = useNavigate();
    const [isExiting, setIsExiting] = useState(false);
    const [width, setWidth] = useState(100);

    const handleClose = (e) => {
        if (e) e.stopPropagation();
        setIsExiting(true);
        setTimeout(() => {
            removeNotification(notification.id);
        }, 300); // Match animation duration
    };

    const handleClick = () => {
        if (notification.url) {
            navigate(notification.url);
            handleClose();
        }
    };

    useEffect(() => {
        if (notification.duration > 0) {
            const startTime = Date.now();
            const endTime = startTime + notification.duration;

            const timer = setInterval(() => {
                const now = Date.now();
                const remaining = endTime - now;
                const percentage = (remaining / notification.duration) * 100;

                if (percentage <= 0) {
                    clearInterval(timer);
                    setWidth(0);
                    // Removal is handled by context timeout, but we can trigger exit animation here if we want strictly synced visuals
                    // handleClose() // Ensure we don't double remove or have race conditions with context
                } else {
                    setWidth(percentage);
                }
            }, 16); // ~60fps

            return () => clearInterval(timer);
        }
    }, [notification]);

    const getIcon = () => {
        switch (notification.type) {
            case 'success': return <FaCheckCircle />;
            case 'error': return <FaExclamationCircle />;
            case 'warning': return <FaExclamationTriangle />;
            case 'info': return <FaInfoCircle />;
            default: return <FaInfoCircle />;
        }
    };

    return (
        <div
            className={`notification-item ${notification.type} ${isExiting ? 'exiting' : ''} ${notification.url ? 'clickable' : ''}`}
            onClick={handleClick}
            onMouseEnter={() => {
                // Optional: Pause timer on hover logic could go here
            }}
            style={{ cursor: notification.url ? 'pointer' : 'default' }}
        >
            <div className="notification-icon">
                {getIcon()}
            </div>
            <div className="notification-content">
                {notification.message}
            </div>
            <button className="notification-close" onClick={handleClose}>
                <FaTimes />
            </button>

            {notification.duration > 0 && (
                <div
                    className="notification-progress"
                    style={{ width: `${width}%` }}
                />
            )}
        </div>
    );
};

export default NotificationItem;
